module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0, false, false), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "container"
  }, [_vm._m(1, false, false), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-offset-3 col-sm-6"
  }, [_c('h4', {
    staticClass: "text-center"
  }, [_vm._v("會員註冊")]), _vm._v(" "), _c('div', {
    staticClass: "register_form"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": "account"
    }
  }, [_vm._v("*帳號(Email)")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.account),
      expression: "account"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "placeholder": "請勿輸入特殊符號 如:&*_#等符號"
    },
    domProps: {
      "value": (_vm.account)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.account = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": "password"
    }
  }, [_vm._v("*設定密碼")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [((_vm.passwordType ? 'password' : 'text') === 'checkbox') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "password",
      "placeholder": "密碼",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.password) ? _vm._i(_vm.password, null) > -1 : (_vm.password)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.password,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.password = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.password = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.password = $$c
        }
      }
    }
  }) : ((_vm.passwordType ? 'password' : 'text') === 'radio') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "password",
      "placeholder": "密碼",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.password, null)
    },
    on: {
      "change": function($event) {
        _vm.password = null
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "password",
      "placeholder": "密碼",
      "type": _vm.passwordType ? 'password' : 'text'
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.displaypwd
    },
    on: {
      "click": function($event) {
        _vm.onChange($event)
      }
    }
  }), _vm._v(" 顯示密碼\n                                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": "password"
    }
  }, [_vm._v("*再次輸入密碼")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.doublepassword),
      expression: "doublepassword"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "doublepassword",
      "placeholder": "再次輸入密碼"
    },
    domProps: {
      "value": (_vm.doublepassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.doublepassword = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": "name"
    }
  }, [_vm._v("*姓名")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "name",
      "placeholder": "請填寫中文本名"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": "phone"
    }
  }, [_vm._v("*行動電話")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "10",
      "id": "phone",
      "placeholder": "行動電話"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": "idno"
    }
  }, [_vm._v("*身分證字號/居留證號碼")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.identify),
      expression: "identify"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "10",
      "id": "idno",
      "placeholder": "身分證字號"
    },
    domProps: {
      "value": (_vm.identify)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.identify = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": "address"
    }
  }, [_vm._v("地址")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.countyval),
      expression: "countyval"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.countyval = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.county), function(option) {
    return _c('option', {
      domProps: {
        "value": option.value
      }
    }, [_vm._v("\n                                                " + _vm._s(option.text) + "\n                                            ")])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.districtval),
      expression: "districtval"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.districtval = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.district), function(option) {
    return _c('option', {
      domProps: {
        "value": option.value
      }
    }, [_vm._v("\n                                                " + _vm._s(option.text) + "\n                                            ")])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": "address"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address),
      expression: "address"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.address = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": "phone"
    }
  }, [_vm._v("推薦人編號")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.parentid),
      expression: "parentid"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "disabled": _vm.validated == 1,
      "id": "parentid",
      "placeholder": "推薦人編號"
    },
    domProps: {
      "value": (_vm.parentid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.parentid = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-offset-3 col-sm-9"
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.member_policy),
      expression: "member_policy"
    }],
    attrs: {
      "type": "checkbox",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.member_policy) ? _vm._i(_vm.member_policy, "1") > -1 : (_vm.member_policy)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.member_policy,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.member_policy = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.member_policy = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.member_policy = $$c
        }
      }
    }
  }), _vm._v("\n                                                我同意"), _c('a', {
    attrs: {
      "href": "/member_policy",
      "target": "_blink"
    }
  }, [_vm._v("遵守「會員條款」之內容")])]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agreement),
      expression: "agreement"
    }],
    attrs: {
      "type": "checkbox",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.agreement) ? _vm._i(_vm.agreement, "1") > -1 : (_vm.agreement)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.agreement,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.agreement = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.agreement = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.agreement = $$c
        }
      }
    }
  }), _vm._v("\n                                                我同意"), _c('a', {
    attrs: {
      "href": "/privacy",
      "target": "_blink"
    }
  }, [_vm._v("「隱私權政策」之內容")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-offset-3 col-sm-9"
  }, [_c('pulse-loader', {
    attrs: {
      "loading": _vm.loading
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "disabled": this.flag
    },
    on: {
      "click": function($event) {
        _vm.register()
      }
    }
  }, [_vm._v("註冊")])], 1)])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "container"
  }, [_c('figure', [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/images/index/i80banner.png"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticClass: "breadcrumb hidden-xs"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("首頁")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/member"
    }
  }, [_vm._v("會員中心")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("註冊")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c3dace3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Register.vue
// module id = 287
// module chunks = 1